const reducers = {
    poi (res) {
        const doc = {};
        doc.address = {
            endereco: res.logradouro,
            bairro: res.neighborhood,
            cidade: res.county,
            uf: res.federativeUnit,
            regiao: res.region,
            cep: res.cep
        };

        doc.information = {
            nome: res.name,
            numero: res.number,
            cluster: res.cluster,
            descricao: res.description,
            tipo: res.type ? res.type.name : ''
        };

        doc.location = {
            latitude: res.latitude,
            longitude: res.longitude
        };

        return doc;
    }
};

export default reducers;



// WEBPACK FOOTER //
// ./src/scripts/api/endpoints/pointOfInterest/reducers.js